import React from 'react';
import styles from './ListSkeleton.module.scss';

interface Props {
	rows?: number;
	compact?: boolean;
}

const ListSkeleton: React.FC<Props> = ({ rows = 6, compact = false }) => (
	<div
		className={compact ? styles.wrapperCompact : styles.wrapper}
		aria-hidden='true'>
		{[...Array(rows)].map((_, index) =>
			compact ? (
				<div className={`${styles.bar} ${styles.w70}`} key={index} />
			) : (
				<div className={styles.row} key={index}>
					<div className={styles.avatar} />
					<div className={styles.stack}>
						<div className={`${styles.bar} ${styles.w50}`} />
						<div className={`${styles.bar} ${styles.w70}`} />
						<div className={`${styles.bar} ${styles.w30}`} />
					</div>
					<div className={styles.action} />
				</div>
			),
		)}
	</div>
);

export default ListSkeleton;
